var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("セッションの有効期限が切れています。")]),_c('h3',[_vm._v("5秒後にログインページにリダイレクトします。お手数ですが再ログインしてください。")])])}]

export { render, staticRenderFns }